/**
 * Gets the effective date (first day) of a given month and year.
 * @param month - 1-indexed month (1 = January, 12 = December)
 * @param year - Full year (e.g., 2024)
 * @returns Formatted date string as "MM/DD/YYYY"
 */
export const getEffectiveDate = (month: number, year: number): string => {
  // Format with leading zeros for month and day
  const formattedMonth = month.toString().padStart(2, "0");
  return `${formattedMonth}/01/${year}`;
};
